import { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../../assets/images/logo_horizontal_verde.png';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src={logo} alt="Clínica Gerações" />
        </div>

        <button className="navbar-hamburger" onClick={toggleMenu} aria-label="Menu">
          <span className={menuOpen ? 'active' : ''}></span>
          <span className={menuOpen ? 'active' : ''}></span>
          <span className={menuOpen ? 'active' : ''}></span>
        </button>

        <ul className={`navbar-menu ${menuOpen ? 'navbar-menu-open' : ''}`}>
          <li><a href="#home" onClick={closeMenu}>Home</a></li>
          <li><a href="#clinica" onClick={closeMenu}>Clínica</a></li>
          <li><a href="#especialidades" onClick={closeMenu}>Especialidades</a></li>
          <li><a href="#profissionais" onClick={closeMenu}>Profissionais</a></li>
          <li><a href="#missao" onClick={closeMenu}>Missão</a></li>
          <li><a href="#artigo" onClick={closeMenu}>Artigo</a></li>
          <li><a href="#contato" onClick={closeMenu}>Contato e Localização</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
